// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1IYuI","question":"Question_question__3inK7","description":"Question_description__2NQT_"};